import React, { useState } from 'react';
import "@styles/SingleHotelViewcss/OrderTable.css";
import { Order, OrdersResponse } from 'types/orders/orderTypes';
import arrow from '@images/back.png';

interface PaginationProps {
  totalPages: number;
  number: number;
  isFirstPage: boolean;
  isLastPage: boolean;
  onPageChange: (newPage: number) => void;
}

const PaginationControls: React.FC<PaginationProps> = ({
  totalPages,
  number,
  isFirstPage,
  isLastPage,
  onPageChange,
}) => {
  return (
    <div style={{ justifyContent: "flex-end", margin: 10, display: "flex", gap: 10, alignItems: "center", marginBottom: "20px", paddingBottom: "10px" }}>
      <span>
        Page {number + 1} of {totalPages}
      </span>
      <button
        onClick={() => onPageChange(number - 1)}
        disabled={isFirstPage}
        style={{ width: 35, height: 35, alignItems: "center" ,border:"none",borderRadius:3,backgroundColor:isFirstPage?"#ccc":"#c7c4bf",cursor:"pointer"}}
      >
        <img src={arrow} alt="<" />
      </button>
      <button
        onClick={() => onPageChange(number + 1)}
        disabled={isLastPage}
        style={{ width: 35, height: 35, alignItems: "center",border:"none",borderRadius:3 ,backgroundColor:isLastPage?"#ccc":"#c7c4bf",cursor:"pointer"}}
      >
        <img src={arrow} alt=">" style={{ transform: "rotate(180deg)" }} />
      </button>
    </div>
  );
};

const OrderTable: React.FC<OrdersResponse> = ({
  content,
  totalElements,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const rowsPerPage = 4;
  const totalPages = Math.ceil(totalElements / rowsPerPage);

  const slicedData = content.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage);

  const handlePageChange = (newPage: number) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="order-table-container">
      <table>
        <thead>
          <tr>
            <th>Order ID No.</th>
            <th>Order Items</th>
            <th>Order Status</th>
            <th>Order Amount</th>
          </tr>
        </thead>
        <tbody>
          {slicedData.map((order) => (
            <tr key={order.orderId}>
              <td className='orderId'>#{order.uniqueOrderid}</td>
              <td>
                <ul className="order-items-list" style={{ listStyleType: "none", display: "flex" }}>
                  {order.items.map((item) => (
                    <li key={item.itemId} style={{ marginRight: 5 }}>
                      {item.menuItemName || "null"}
                    </li>
                  ))}
                </ul>
              </td>
              <td className={`status ${order.status.toLowerCase()}`}>
                {order.status === "ORDER_CONFIRMED" ? "ORDER CONFIRMED" : order.status}
              </td>
              <td>₹{order.totalPrice.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <PaginationControls
        totalPages={totalPages}
        number={currentPage}
        isFirstPage={currentPage === 0}
        isLastPage={currentPage === totalPages - 1}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default OrderTable;
